import { render, staticRenderFns } from "./SideBarInTimeShiftMode.vue?vue&type=template&id=6566a272&scoped=true&"
import script from "./SideBarInTimeShiftMode.vue?vue&type=script&lang=js&"
export * from "./SideBarInTimeShiftMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6566a272",
  null
  
)

export default component.exports